// antd
import React from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
// Components
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import routePathEnum from 'enums/routePathEnum';

interface ILogin {}

const Logout: React.FC<ILogin> = () => {
    const { navigateWorkaround } = useNavigateWorkaround();

    return (
        <AuthWrapper>
            <Title text="LOGOUT_TITLE" level={5} />
            <Paragraph
                text="LOGOUT_TEXT"
                style={{
                    paddingTop: 10,
                    display: 'block'
                }}
            />
            <div
                style={{
                    display: 'block',
                    paddingTop: 40
                }}
            >
                <ButtonComponent
                    buttontext="PRIHLASIT_SE"
                    style={{
                        marginRight: 20
                    }}
                    type="primary"
                    onClick={() => navigateWorkaround(routePathEnum.LOGIN_ROZCESTNIK)}
                    id="loginRedirectBtn"
                />
                <AnchorComponent href="https://www.cdcp.cz/">
                    <ButtonComponent buttontext="PREJIT_NA_CDCP" type="primary" id="cdcpRedirectBtn" />
                </AnchorComponent>
            </div>
        </AuthWrapper>
    );
};

export default Logout;
